import { useContext } from 'react';
import { FeatureFlagsContext, FeatureFlagsContextType } from '../feature-flags.context';

export const useFeatureFlagsContext = (): FeatureFlagsContextType =>
    useContext<FeatureFlagsContextType>(FeatureFlagsContext);
